import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, Entity, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityGrid, EntityTypeCardsProvider, Video } from '@shapeable/ui';
import { CourseCuratorCard } from './course-curator-card';

import { FeedEntryCuratorCard } from './feed-entry-curator-card';
import { PostCuratorCard } from './post-curator-card';
import { ProgramCuratorCard } from './program-curator-card';
import { VideoCuratorCard } from './video-curator-card';
import { LinkCuratorCard } from './link-curator-card';
import { EventCuratorCard } from './event-curator-card';

const cls = classNames('slice-curator-cards-grid');

// -------- Types -------->

// -------- Props -------->

export type SliceCuratorCardsGridProps = Classable & HasChildren & { 
  entity?: Slice;
};

export const SliceCuratorCardsGridDefaultProps: Omit<SliceCuratorCardsGridProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const GridStyles = breakpoints({
  base: css`
    .shp--entity-card__border {
      &:hover {
        box-shadow: 0 0 16px 2px ${theme.COLOR('subtle-shadow')};
      }
    }
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Grid: styled(EntityGrid)`${GridStyles}`,
};

export const SliceCuratorCardsGrid: Shapeable.FC<SliceCuratorCardsGridProps> = (props) => {
  const { className, children, entity } = props;

  const items = [
    ...entity?.programs || [],
    ...entity?.courses || [],
    ...entity?.feedEntries || [],
    ...entity?.posts || [],
    ...entity?.videos || [],
    ...entity?.events || [],
    ...entity?.links || [],
  ].slice(0, 6) as Entity[];
  
  return (
    <EntityTypeCardsProvider value={{
      Course: CourseCuratorCard,
      Event: EventCuratorCard,
      FeedEntry: FeedEntryCuratorCard,
      Post: PostCuratorCard,
      Program: ProgramCuratorCard,
      Video: VideoCuratorCard,
      Link: LinkCuratorCard,
    }}>
    <My.Container className={cls.name(className)}>
      <My.Grid 
        items={items}
        maxColumns={3}
        spacing={5}
        />
    {children}
    </My.Container>
    </EntityTypeCardsProvider>
  )
};

SliceCuratorCardsGrid.cls = cls;